module.exports = __webpack_public_path__ + "static/media/lesson-backto15.ce8b6413.png";